/* tslint:disable */

import { ConcreteFragment } from "relay-runtime";
export type NewTradeModal_viewer$ref = any;
export type NewTradeModal_viewer = {
    readonly currentTradePrice: ({
        readonly zarPerTroyOunce: number;
        readonly usdPerTroyOunce: number;
        readonly zarToUsd: number;
    }) | null;
    readonly companies: ({
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly runningBalance: number;
                readonly tradeLimit: {
                    readonly limit: number;
                };
                readonly id: string;
                readonly info: {
                    readonly name: string;
                };
            };
        }>;
    }) | null;
    readonly " $refType": NewTradeModal_viewer$ref;
};



const node: ConcreteFragment = {
  "kind": "Fragment",
  "name": "NewTradeModal_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentTradePrice",
      "storageKey": null,
      "args": null,
      "concreteType": "TradePrice",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "zarPerTroyOunce",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "usdPerTroyOunce",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "zarToUsd",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "companies",
      "storageKey": null,
      "args": null,
      "concreteType": "ViewerCompaniesConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ViewerCompaniesEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Company",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "runningBalance",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "tradeLimit",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CompanyTradeLimit",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "limit",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "info",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CompanyInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "name",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '73eade36c4c6549b6ac10275d0383e3e';
export default node;
